import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { AiListeningBrandProfileApiService } from 'src/services/aiListeningApi/brandProfile'

export const useGetAiListeningSiteAuditQuery = (
  profileId: string,
  subjectId: string
) => {
  return useQuery({
    enabled: !!profileId && !!subjectId,
    queryFn: () =>
      AiListeningBrandProfileApiService.getSiteAudit(profileId, subjectId),
    queryKey: [
      QueryKey.GET_AI_LISTENING_PROFILE_SITE_AUDIT,
      profileId,
      subjectId,
    ],
  })
}
